import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
    token: string | null;
    // The superadmin's own token, stashed while an impersonation token is
    // active so "Exit" can restore the session without a re-login.
    previousToken: string | null;
}

const initialState: AuthState = {
    token: localStorage.getItem('token'),
    previousToken: localStorage.getItem('previousToken'),
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string | null>) => {
            state.token = action.payload;

            if (action.payload) {
                localStorage.setItem('token', action.payload);
            } else {
                localStorage.removeItem('token');
            }
        },
        startImpersonation: (state, action: PayloadAction<string>) => {
            state.previousToken = state.token;
            state.token = action.payload;

            if (state.previousToken) {
                localStorage.setItem('previousToken', state.previousToken);
            }
            localStorage.setItem('token', action.payload);
        },
        endImpersonation: (state) => {
            state.token = state.previousToken;
            state.previousToken = null;

            if (state.token) {
                localStorage.setItem('token', state.token);
            } else {
                localStorage.removeItem('token');
            }
            localStorage.removeItem('previousToken');
        },
    },
});

export const { setToken, startImpersonation, endImpersonation } = authSlice.actions;
export default authSlice.reducer;
